module.exports = __webpack_public_path__ + "static/media/icon-booth-food.9b22140a.svg";